import React, { useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { FaFolderOpen } from 'react-icons/fa';
import config from '../config/config';

// Depois de gerar a OS (só quando ela tem veículo): "Deseja abrir o processo deste atendimento?"
// Sim -> POST /processos/da-ordem/{id}: um processo por veículo, já com cliente, veículo e serviços da OS, e
// abre a tela de Processos nele (pendente de upload). Agora não -> segue como sempre (lista de OS).
function ModalProcessoDaOrdem({ ordem, quantidadeVeiculos, onAbrir, onPular }) {
  const { API_BASE_URL } = config;
  const [abrindo, setAbrindo] = useState(false);
  const [erro, setErro] = useState('');

  const abrir = async () => {
    setAbrindo(true);
    setErro('');
    try {
      const { data } = await axios.post(`${API_BASE_URL}/processos/da-ordem/${ordem.id}`, [], {   // lista vazia = todos os veículos (sem corpo, o axios manda form-urlencoded e o back recusa)
        headers: { Authorization: `Bearer ${localStorage.getItem('jwtToken')}` },
      });
      onAbrir(data || []);
    } catch (error) {
      setErro(error.response?.data?.message || 'Não foi possível abrir o processo. Você pode abrir depois pela tela de Processos.');
      setAbrindo(false);
    }
  };

  return (
    <Fundo>
      <Caixa role="dialog" aria-modal="true">
        <Icone><FaFolderOpen size={24} /></Icone>
        <h3>Abrir o processo deste atendimento?</h3>
        <p>
          A OS {ordem.numeroOrdem ? <strong>{ordem.numeroOrdem}</strong> : ''} foi gerada.
          {quantidadeVeiculos > 1
            ? <> Serão abertos <strong>{quantidadeVeiculos} processos</strong>, um por veículo,</>
            : <> O processo é aberto</>}
          {' '}já com cliente, veículo e serviços preenchidos — falta só enviar os documentos escaneados.
        </p>
        {erro && <Erro>{erro}</Erro>}
        <Botoes>
          <button type="button" className="secundario" onClick={onPular} disabled={abrindo}>Agora não</button>
          <button type="button" className="primario" onClick={abrir} disabled={abrindo}>
            {abrindo ? 'Abrindo...' : 'Sim, abrir processo'}
          </button>
        </Botoes>
      </Caixa>
    </Fundo>
  );
}

const Fundo = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 1100;
`;

const Caixa = styled.div`
  width: 100%;
  max-width: 440px;
  background: white;
  border-radius: 14px;
  padding: 26px 24px 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.25);
  text-align: center;
  box-sizing: border-box;
  h3 { margin: 12px 0 8px 0; color: #004d4d; font-size: 1.15rem; }
  p { margin: 0; color: #5f6f6f; font-size: 0.9rem; line-height: 1.5; }
`;

const Icone = styled.div`
  width: 52px;
  height: 52px;
  margin: 0 auto;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eaf6f6;
  color: #008080;
`;

const Erro = styled.p`
  margin-top: 10px !important;
  color: #c0392b !important;
`;

const Botoes = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
  flex-wrap: wrap;
  button {
    padding: 11px 18px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
  }
  .primario { background: #008080; color: white; border: none; }
  .secundario { background: white; color: #34495e; border: 1px solid #dee2e6; }
  button:disabled { opacity: 0.6; cursor: wait; }
`;

export default ModalProcessoDaOrdem;
